import { render, staticRenderFns } from "./EditParticipantDialog.vue?vue&type=template&id=5c81f24e"
import script from "./EditParticipantDialog.vue?vue&type=script&lang=ts"
export * from "./EditParticipantDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports